import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>© 2024 Art Gallery. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
